<template>
  <div class="emojiPicker active">
    <Picker
      :data="emojiIndex"
      ref="picker"
      set="google"
      class="picker"
      :native="OS !== 'Windows'"
      :title="emojiMartI18n.title + '...'"
      :i18n="emojiMartI18n"
      @select="addEmoji"
    />
  </div>
</template>

<script>
import data from "emoji-mart-vue-fast/data/all.json";
import "emoji-mart-vue-fast/css/emoji-mart.css";
import { Picker, EmojiIndex } from "emoji-mart-vue-fast";
let emojiIndex = new EmojiIndex(data, { exclude: ["flags"] });

export default {
  name: "EmojiPicker",
  components: {
    Picker,
  },

  data() {
    return { emojiIndex: emojiIndex, emojisOutput: "", OS: "" };
  },

  mounted() {
    this.OS = navigator.platform === "Win32" ? "Windows" : "Other";
    this.excludeSpecificEmojis();
  },

  computed: {
    emojiMartI18n() {
      return (
        this.$i18n.messages[this.getWebchat().client.lang].emojis ||
        this.$i18n.messages["en"].emojis
      );
    },
  },
  methods: {
    getWebchat() {
      return this.$store.state[
        this.$store.state.findIndex(
          (e) => e.configuration.campaign === this.$route.query.campaign
        )
      ];
    },
    excludeSpecificEmojis() {
      let listOfEmojisToExclude = ["relaxed"];
      let categories = this.$refs.picker.$data.view._categories;
      for (let category of categories) {
        let emojis = category.emojis;
        category.emojis = emojis.filter(
          (emoji) => !listOfEmojisToExclude.includes(emoji.id)
        );
      }
    },
    addEmoji(emoji) {
      this.$emit("addEmoji", emoji);
    },
  },
};
</script>

<style>
.picker {
  position: fixed;
  bottom: 62px;
  top: auto;
  z-index: 2;
  max-width: calc(100% - 45px);
  max-height: calc(100% - 178px);
}
/* .emoji-mart {
  width: 355px;
  position: absolute;
  z-index: 1;
  top: 50px;
}
.emoji-mart-anchor {
  cursor: pointer;
}
.emoji-mart-category {
  display: flex !important;
  flex-wrap: wrap;
  width: 100%;
  flex-wrap: wrap;
}
.emoji-mart-category-label {
  width: 100%;
}
.emoji-mart-emoji {
  display: flex !important;
}

.emoji-mart-category .emoji-mart-emoji:hover span {
  font-size: 30px !important;
}
.emoji-mart-category .emoji-mart-emoji span {
  display: flex !important;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  transition: 0.2s;
} */
</style>
